import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';
import { OPEN_RESPONSE_CONSTANTS } from '@core/constants/push-live.constants';

@Component({
  selector: 'app-open-response',
  templateUrl: './open-response.component.html',
  styleUrls: ['./open-response.component.css'],
})
export class OpenResponseComponent {
  @Input() isMissing = false;
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue: string;
  }>();

  readonly maxLength = OPEN_RESPONSE_CONSTANTS.MAX_LENGTH;
  readonly inputHint = OPEN_RESPONSE_CONSTANTS.INPUT_HINT;
  charCount = 0;

  get isNearLimit(): boolean {
    return this.charCount >= this.maxLength * 0.9;
  }

  handleInput(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value;
    this.charCount = value.length;

    this.answerSelected.emit({
      questionUuid: this.question.uuid,
      answerValue: value,
    });
  }

  get questionHtml(): string {
    const html = this.question.question || '';
    if (!this.question.is_required) {
      return html;
    }
    const marker = ' <span style="color:#dc2626">*</span>';
    const lastCloseTagIndex = html.toLowerCase().lastIndexOf('</p>');
    if (lastCloseTagIndex === -1) {
      return html + marker;
    }
    return html.slice(0, lastCloseTagIndex) + marker + html.slice(lastCloseTagIndex);
  }
}
